(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/video-analysis-player/assets/javascripts/use-player-polling.js') >= 0) return;  svs.modules.push('/components/tipsen/video-analysis-player/assets/javascripts/use-player-polling.js');
"use strict";


const {
  useCallback,
  useEffect,
  useRef,
  useContext
} = React;
const {
  EngineProviderContext
} = svs.components.tipsen.engine;
const {
  updatePlaybackState,
  clearCurrentVideo
} = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions;
const {
  trackEvent
} = svs.components.analytics;

const POLLING_INTERVAL = 200;
const POLLING_INTERVAL_PAUSED = 600;
const POLLING_INITIALIZATION_DELAY = 1000;

const getPlayerValue = function (playerMethod, videoId) {
  let fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return new Promise(resolve => {
    playerMethod(videoId, result => {
      var _result$value;
      resolve((_result$value = result === null || result === void 0 ? void 0 : result.value) !== null && _result$value !== void 0 ? _result$value : fallback);
    });
  });
};

const usePlayerPolling = (loadedVideo, currentVideo, currentVideoRef, dispatch) => {
  const {
    currentEngine
  } = useContext(EngineProviderContext);
  const {
    brandName
  } = currentEngine || {};
  const pollIntervalRef = useRef(null);
  const currentIntervalRef = useRef(POLLING_INTERVAL);
  const durationRef = useRef(0);
  const positionRef = useRef(0);
  const previousUpdateDataRef = useRef(null);
  const [playerState, setPlayerState] = React.useState({
    position: 0,
    duration: 0,
    isPlaying: false
  });

  const clearPolling = useCallback(() => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }
    previousUpdateDataRef.current = null;
  }, []);

  const updatePlayerState = useCallback(async videoId => {
    if (!svs.components.video_player || !videoId || !currentVideoRef.current) {
      return null;
    }
    try {
      const isReady = await getPlayerValue(svs.components.video_player.isReady, videoId, false);
      const updateData = {
        id: videoId,
        isReady
      };
      let isPlaying = false;
      if (isReady) {
        const [position, duration, playingState] = await Promise.all([getPlayerValue(svs.components.video_player.getPosition, videoId, 0), getPlayerValue(svs.components.video_player.getDuration, videoId, 0), getPlayerValue(svs.components.video_player.isPlaying, videoId, false)]);
        isPlaying = playingState;
        Object.assign(updateData, {
          currentPosition: position,
          duration,
          isPlaying
        });
        setPlayerState({
          position,
          duration,
          isPlaying
        });
      }

      const previousUpdateData = previousUpdateDataRef.current;
      const hasChanged = !previousUpdateData || previousUpdateData.id !== updateData.id || previousUpdateData.isReady !== updateData.isReady || previousUpdateData.currentPosition !== updateData.currentPosition || previousUpdateData.duration !== updateData.duration || previousUpdateData.isPlaying !== updateData.isPlaying;
      if (hasChanged) {
        dispatch(updatePlaybackState(updateData));
        previousUpdateDataRef.current = updateData;

        if (updateData.duration > 0 && updateData.currentPosition >= updateData.duration - 0.5) {
          dispatch(clearCurrentVideo());
        }
      }
      return isPlaying;
    } catch (error) {
      return null;
    }
  }, [dispatch, currentVideoRef]);

  const startPolling = useCallback(videoId => {
    if (!videoId) {
      return;
    }
    clearPolling();
    const poll = async () => {
      const isPlaying = await updatePlayerState(videoId);

      const targetInterval = isPlaying ? POLLING_INTERVAL : POLLING_INTERVAL_PAUSED;

      if (currentIntervalRef.current !== targetInterval) {
        currentIntervalRef.current = targetInterval;
        clearPolling();
        pollIntervalRef.current = setInterval(poll, targetInterval);
      }
    };

    currentIntervalRef.current = POLLING_INTERVAL;
    pollIntervalRef.current = setInterval(poll, POLLING_INTERVAL);
  }, [updatePlayerState, clearPolling]);

  useEffect(() => {
    durationRef.current = playerState.duration;
    positionRef.current = playerState.position;
  }, [playerState.duration, playerState.position]);

  useEffect(() => {
    if (!(loadedVideo !== null && loadedVideo !== void 0 && loadedVideo.videoId) || !currentVideo) {
      return;
    }
    const productLabel = brandName ? brandName.charAt(0).toUpperCase() + brandName.slice(1) : '';
    const videoTitle = (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.description) || (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title);
    trackEvent({
      category: 'Nya tipsen',
      action: 'video start',
      opt_label: "".concat(videoTitle, ". ").concat(productLabel)
    });
    return () => {
      const finalDuration = durationRef.current > 0 ? Math.floor(durationRef.current) : 0;
      const finalPosition = positionRef.current > 0 ? Math.floor(positionRef.current) : 0;
      trackEvent({
        category: 'Nya tipsen',
        action: 'video stop',
        opt_label: "Duration ".concat(finalPosition, " of ").concat(finalDuration, ", ").concat(videoTitle, ". ").concat(productLabel)
      });
    };
  }, [brandName, currentVideo, loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId]);

  useEffect(() => {
    if (!(loadedVideo !== null && loadedVideo !== void 0 && loadedVideo.videoId) || !currentVideo) {
      clearPolling();
      return;
    }

    previousUpdateDataRef.current = null;
    const startPollingTimeout = setTimeout(() => {
      startPolling(loadedVideo.videoId);
    }, POLLING_INITIALIZATION_DELAY);
    return () => {
      clearTimeout(startPollingTimeout);
      clearPolling();
    };
  }, [loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId, currentVideo, startPolling, clearPolling]);

  useEffect(() => () => clearPolling(), [clearPolling]);
  return playerState;
};
setGlobal('svs.components.tipsen.videoAnalysisPlayer.usePlayerPolling', usePlayerPolling);

 })(window);